module.exports = __webpack_public_path__ + "static/media/mohre.b801b690.mp3";